.operationInfo {
  position: relative;
}

.operationInfo::after {
  position: absolute;
  width: 1px;
  height: calc(100% + 50%);
  background-color: rgba(0, 0, 0, 1);
  content: " ";
  top: 30px;
  left: 60%;
}

.operation:last-child .operationInfo::after {
  content: none; /* Removes the pseudo-element */
}

.operationCertificateImage {
  margin-right: 8px;
}

.operationCertificates {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}
.operationCertificate {
  border: 1px black solid;
  border-radius: 4px;
  padding: 6px 12px;
  display: flex;
  font-size: 12px;
  align-items: flex-start;
  margin-right: 8px;
  margin-bottom: 8px;
}
.operationCertificates {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}

.root {
  width: 100%;
  color: var(--text-color);
}

.step {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.steps {
  align-items: flex-start;
  justify-content: flex-start;
}

@media (max-width: 1200px) {
  .step {
    justify-content: space-between;
    width: 90%;
  }
}

@media (max-width: 556px) {
  .step {
    justify-content: space-between;
    width: 100%;
  }
}

.stepIcon {
  background-color: transparent;
  border: none;
  color: var(--text-color);
  width: auto;
  display: inline-block;
}

.stepIcon div {
  background-color: transparent;
  border: none;
  width: auto;
  word-wrap: break-word;
}

.stepWrapper {
  max-width: 50%;
  width: 100%;
}
.stepBody {
  width: 50%;
  align-items: flex-start;
  margin: 0;
}

.stepDescription {
  color: inherit;
}

.verticalSeparator {
  border-color: black;
}

.countryName {
  text-transform: uppercase;
  font-size: var(--text-fz);
}

.activityName {
  font-size: var(--text-fz);
  text-transform: uppercase;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
